import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import ProfileDropdown from "./ProfileDropDown";
import logo from "../images/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/actions/authActions";

const navigation = [
  { name: "Dashboard", href: "/dashboard" },
  { name: "Users", href: "/users" },
  { name: "Websites", href: "/websites" },
  { name: "Payments", href: "/payments" },
  { name: "Change Password", href: "/change-password" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    const res = dispatch(logout());

    if (res) {
      navigate("/");
    }
  };

  const { user } = useSelector((state) => state.auth);
  return (
    <>
      <div className="sticky top-0 z-50">
        <Disclosure
          as="nav"
          className="bg-white h-20  border-b-2 border-gray-200 drop-shadow-sm transition-all duration-300 py-2 "
        >
          {({ open }) => (
            <>
              <div className="2xl:px-10 xl:px-10 lg:px-10 md:px-6 px-3">
                <div className="flex h-16 items-center justify-between">
                  <div className="flex items-center">
                    <div
                      className=" w-[170px] cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      <img src={logo} alt="SEO Insights" />
                    </div>
                  </div>
                  <div className="hidden md:block">
                    <div className="flex items-center md:ml-6">
                      {/* Profile dropdown */}
                      <ProfileDropdown />
                    </div>
                  </div>
                  <div className="-mr-2 flex md:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md ring-2 ring-gray-200 p-2 mr-3 focus:ring-2 focus:ring-indigo-300">
                      <span className="absolute -inset-0.5" />
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      ) : (
                        <Bars3Icon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      )}
                    </Disclosure.Button>
                  </div>
                </div>
              </div>

              <Disclosure.Panel className="md:hidden bg-white shadow-sm transition-all duration-300">
                <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3 flex flex-col gap-1">
                  {navigation.map((item) => (
                    <NavLink
                      key={item.name}
                      to={item.href}
                      className={({ isActive }) => {
                        return isActive
                          ? "bg-indigo-100 w-full flex p-2 rounded-[8px] px-3 mt-4 antialiased tracking-normal"
                          : "flex px-3 mt-4 p-2 antialiased tracking-normal";
                      }}
                    >
                      {item.name}
                    </NavLink>
                  ))}
                </div>
                <div className="border-t border-gray-700 pb-3 pt-4">
                  <div className="flex items-center px-5">
                    <div className="hover:ring-2 hover:ring-indigo-100 rounded-full bg-slate-100 hover:transition-all hover:duration-300 w-10 h-10 flex items-center justify-center cursor-pointer">
                      <p className="text-center font-medium text-[22px]">
                        {user?.name?.substr(0, 1)}
                      </p>
                    </div>
                    <div className="ml-3">
                      <div className="text-base font-medium leading-none ">
                        {user.name}
                      </div>
                      <div className="text-sm font-medium leading-none text-gray-400 mt-1">
                        {user.email}
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 space-y-4 px-3 mb-3">
                    <button
                      onClick={() => handleLogout()}
                      className="bg-indigo-400 w-full mt-5 space-y-1 h-10 rounded-[8px] text-white"
                    >
                      Logout
                    </button>
                  </div>

                  <div></div>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </>
  );
}
